import React from 'react'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';


export default function Reviews() {

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};

  return (
    <>
      <section className="reviews">
    <div className="container">
        <div className="row">
            <div className="col-md-12">
                <h2 className="heading">Stories Shared by Fellow Travelers</h2>
            </div>
 <Carousel responsive={responsive}infinite={true}autoPlay={true}autoPlaySpeed={3000}swipeable={true} draggable={true}ssr={true}removeArrowOnDeviceType={["tablet", "mobile"]}>

           
                <div className="subReview">
                    <h3>Wonderful experience during my Dubai trip</h3>
                    <p>Had a wonderful experience during my Dubai trip with Unlock Destination!The service was excellent, and the team was very responsive to all our queries. The hotel they booked was great, and all the events were perfectly organized without any hassle. The transport arrangements for pick-up and drop-off were also smooth and comfortable. A big thanks to Aakash and the team for planning everything so well and making our vacation truly enjoyable!</p>    
                    <p className="text-end fst-italic mb-4" style={{color:"#666"}}>- Sorabh Dhamija</p>
                </div>
            
            
                <div className="subReview">
                    <h3>Amazing experience with Unlock Destinations</h3>
                    <p>We had an amazing experience with Unlock Destinations. It was our honeymoon at Maldives, the entire tour was organised very well and hassle-free. Very happy with the service. Highly recommended!</p>    
                    <p className="text-end fst-italic mb-4" style={{color:"#666"}}>- Varun Kumar G</p>
                </div>
            
            
                <div className="subReview">
                    <h3>Everything was seamless and truly exceeded my expectations</h3>
                    <p>I wanted to take a moment to express my deepest gratitude for all your hard work in organizing my recent trip to Bali. From start to finish, everything was seamless and truly exceeded my expectations. Your attention to detail and expertise made the experience unforgettable. Thank Sangeetha for making my dream vacation a reality!</p>    
                    <p className="text-end fst-italic mb-4" style={{color:"#666"}}>- Sinchan H S</p>

                </div>
            
            
                <div className="subReview">
                    <h3>It was a smooth trip for us</h3>
                    <p>We took Phuket-Krabi package from Unlock Destinations, and it was a smooth trip for us. From managing the bookings to customising itinerary as per our preferences to being approachable all time. Even last minute modification to the planned itinerary for convenient setup was arranged, which was really impressive.100% satisfied with the service. Thanks to Akash & team for the comfortable and convenient trip. Would recommend this.</p>    
                    <p className="text-end fst-italic mb-4" style={{color:"#666"}}>- Shubhesh Goel</p>
                </div>
            

            </Carousel>
        </div>
    </div>
</section>
    </>
  )
}
